import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title = "Gebäudereinigung Berlin & Umgebung | M.F.D. & CO",
  description = "Gebäudereinigung in Berlin und Umgebung: Unterhalt, Glas, Fassade, Bau, Grund- und Teppichreinigung. M.F.D. & CO in Tempelhof – Angebot anfordern.",
  keywords = "Gebäudereinigung Berlin, Gebäudereinigung Berlin Umgebung, Reinigungsfirma Berlin, Büroreinigung Berlin, Gebäudereinigung Tempelhof, Reinigung Potsdam, Reinigung Teltow, Reinigung Schönefeld, Unterhaltsreinigung Berlin, Baureinigung Berlin",
  image = "https://www.mfd-berlin.com/logomfd.jpg",
  url = "https://www.mfd-berlin.com/",
  type = "website",
  noindex = false,
}) => {
  const fullTitle = title.includes("M.F.D.") ? title : `${title} | M.F.D. & CO Gebäudereinigung Berlin`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:secure_url" content={image} />
      <meta property="og:site_name" content="M.F.D. & CO Gebäudereinigung" />
      <meta property="og:locale" content="de_DE" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Geo Tags */}
      <meta name="geo.region" content="DE-BE" />
      <meta name="geo.placename" content="Berlin" />
      <meta name="geo.position" content="52.488889;13.369393" />
      <meta name="ICBM" content="52.488889, 13.369393" />
    </Helmet>
  );
};

export default SEO;

